export default __webpack_public_path__ + "static/media/cctv.86972a6e.svg";